/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconEditFilled from 'DesignSystem/Svgs/TysiaIconEditFilled/index'



/** @type {import('Simple/types.js').View} */
export default function EditAction({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/BlockedTime/BlockedTimeDialog/EditAction"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 onClick={onClick}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconEditFilled
{...childProps}
  viewPath={`${viewPath}/TysiaIconEditFilled`}
 width={16}
 height={16}
 fill={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}